<template>
  <section id="hero" class="relative min-h-screen flex items-start overflow-hidden pb-40 md:pb-48 lg:pb-56">
    <!-- Background image -->
    <div class="absolute inset-0 z-0">
      <img
        src="/images/hero-bg.webp"
        alt="Background"
        class="w-full h-full object-cover"
        loading="eager"
        fetchpriority="high"
      />
      <div class="absolute inset-0 bg-black/30"></div>
    </div>

    <!-- Animated Logo (fixed position, moves on scroll) -->
    <div
      ref="logoContainer"
      class="fixed z-50 transition-all duration-500 ease-out"
      :style="logoStyle"
    >
      <img
        ref="logo"
        src="/images/logo-hero.svg"
        alt="Comptoir Gascon"
        class="h-auto transition-all duration-500 ease-out"
        :style="{ width: logoWidth + 'px' }"
      />
    </div>

    <!-- Content -->
    <div class="relative z-10 container mx-auto px-4 md:px-8 pt-8 md:pt-16 text-white">
      <!-- Logo placeholder (invisible, keeps space) -->
      <div class="mb-4 md:mb-12 h-48 md:h-32 lg:h-40"></div>

      <!-- Main content with title on left -->
      <div class="flex flex-col px-4 md:px-12 lg:flex-row lg:items-center lg:justify-between">
        <!-- Left side: Title and phone box -->
        <div class="lg:max-w-3xl text-center md:text-left">
          <!-- Tagline -->
          <h1 class="text-2xl md:text-4xl lg:text-5xl font-bold font-din leading-tight">
            Le Comptoir Gascon,
          </h1>
          <p class="text-lg md:text-2xl lg:text-3xl mb-2 md:mb-4 font-raleway">
            le QG des professionnels de la restauration.
          </p>
          <p class="text-base md:text-xl text-white mb-6 md:mb-8">
            Spécialiste des brasseries de Bordeaux.
          </p>
        </div>

        <!-- Right side: Map of Gironde -->
        <div class="hidden lg:block lg:flex-shrink-0 lg:ml-8">
          <img
            src="/images/carte_gironde.svg"
            alt="Zones de livraison en Gironde"
            class="w-80 xl:w-[28rem] 2xl:w-[32rem] h-auto drop-shadow-2xl"
          />
        </div>
      </div>

      <!-- Map for mobile & tablet (centered below) -->
      <div class="mt-8 md:mt-12 text-center lg:hidden">
        <img
          src="/images/carte_gironde.svg"
          alt="Zones de livraison en Gironde"
          class="w-80 md:w-96 h-auto mx-auto drop-shadow-2xl"
        />
      </div>
    </div>

  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  data() {
    return {
      scrollY: 0,
      windowWidth: 0,
      startLogoWidth: 520, // lg:w-96
      endLogoWidth: 120,
      scrollThreshold: 300
    }
  },
  computed: {
    scrollProgress() {
      return Math.min(1, this.scrollY / this.scrollThreshold)
    },
    logoWidth() {
      // Responsive start width
      let startWidth = this.startLogoWidth
      if (this.windowWidth < 768) {
        startWidth = 256 // w-64
      } else if (this.windowWidth < 1024) {
        startWidth = 320 // md:w-80
      }
      return startWidth - (startWidth - this.endLogoWidth) * this.scrollProgress
    },
    logoStyle() {
      const progress = this.scrollProgress

      // Start position: centered horizontally, top of hero
      const startTop = 60 // pt-8
      const startLeft = (this.windowWidth - this.logoWidth) / 2

      // End position: in header (left side with some padding)
      const endTop = 0
      const endLeft = (this.windowWidth / 2) - (this.endLogoWidth / 2) // Stay centered in header

      const currentTop = startTop + (endTop - startTop) * progress
      const currentLeft = startLeft + (endLeft - startLeft) * progress

      return {
        top: currentTop + 'px',
        left: currentLeft + 'px'
      }
    }
  },
  mounted() {
    this.windowWidth = window.innerWidth
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleScroll() {
      this.scrollY = window.scrollY
    },
    handleResize() {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>
